import { QueryClient } from '@tanstack/react-query';

/**
 * Глобальный singleton React Query клиента — выделен в отдельный модуль,
 * чтобы можно было обратиться к нему не только из React-дерева (через
 * useQueryClient), но и из обычных модулей (например, auth store в logout
 * чтобы очистить кеш предыдущего пользователя).
 *
 * Импортируется в main.tsx как `<QueryClientProvider client={queryClient}>`
 * и в `stores/auth.ts` для `.clear()` при выходе.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 24 * 60 * 60 * 1000,
      retry: (failureCount, error) => {
        const status = (error as { status?: number })?.status;
        if (status && status >= 400 && status < 500 && status !== 408 && status !== 429) {
          return false;
        }
        return failureCount < 2;
      },
      networkMode: 'offlineFirst',
    },
    mutations: {
      networkMode: 'offlineFirst',
    },
  },
});
